import { BagResponseV4, updateProduct } from "@repo/apis/bag";
import { setBagCookies } from "../utils/bag-cookies";
import { handleApiInteractionError } from "../utils/handle-api-interaction-error";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicUpdateProductMethod = (params: {
  variantId: number;
  quantity: number;
  bagItemId: string;
}) => Promise<BagResponseV4>;

type UpdateProductMethod = BagSdkMethod<PublicUpdateProductMethod>;

export const updateProductInitialiser: UpdateProductMethod =
  ({
    chameleonRequestInstance,
    store,
    lang,
    getAuthHeaderPredicate,
    state,
    country,
  }) =>
  async ({ variantId, quantity, bagItemId }) => {
    const authHeader = await getAuthHeaderPredicate();
    const bag = state.getBag();
    const bagSessionToken = state.getBagSessionToken();
    const bagExpansions = state.getBagExpansions();

    if (!bag) {
      throw new Error("Failed to update product. The bag does not exist");
    }

    const bagId = bag.id;

    try {
      const updateProductResult = await updateProduct({
        chameleonRequestInstance,
        variantId,
        quantity,
        bagItemId,
        store,
        lang,
        authHeader,
        asosBagSessionToken: bagSessionToken as string,
        bagId,
        expand: bagExpansions,
      });

      state.setBag(updateProductResult.data.bag);
      state.setBagSessionToken(updateProductResult.bagSessionToken);

      setBagCookies(
        { store, country },
        {
          bagId: updateProductResult.data.bag.id,
          bagOrigin: updateProductResult.data.bag.origin,
          sessionToken: updateProductResult.bagSessionToken,
        },
      );

      return updateProductResult.data;
    } catch (error: unknown) {
      return handleApiInteractionError(error);
    }
  };
